export const reportGameGroups = [
  { value: 'all-dcx', label: '所有大吃小', templates: ['pjx', 'paijiu'] },
  { value: 'all-fantan', label: '所有番摊', templates: ['fantan'] },
]

export function isReportGameGroup(value) {
  return reportGameGroups.some((group) => group.value === value)
}

export function reportGameIds(value, games) {
  const group = reportGameGroups.find((item) => item.value === value)
  if (!group) return value
  // An empty group must never fall back to querying every game.
  return games.filter((game) => group.templates.includes(game.game_template))
    .map((game) => game.game_id).join(',') || '-1'
}
